module["exports"] = [
  "gmail.com",
  "yahoo.com",
  "hotmail.com"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/de_AT/internet/free_email.js
 ** module id = 250
 ** module chunks = 0
 **/